import React from 'react';
import { motion } from 'framer-motion';

const ParadigmShift = () => (
  <section id="anmeldung" className="relative py-36 overflow-hidden border-t border-gold/20">
    <div className="absolute inset-0 bg-dark" />
    <motion.div
      animate={{ opacity: [0.3, 0.7, 0.3], scale: [1, 1.1, 1] }}
      transition={{ duration: 8, repeat: Infinity }}
      className="absolute inset-0 pointer-events-none"
      style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(212,175,55,0.09) 0%, transparent 65%)' }}
    />
    {[...Array(20)].map((_, i) => (
      <motion.div key={i} className="absolute rounded-full bg-gold pointer-events-none"
        style={{ width: Math.random() * 4 + 1, height: Math.random() * 4 + 1, left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`, opacity: 0.2 }}
        animate={{ y: [-40, 40, -40], opacity: [0.05, 0.5, 0.05] }}
        transition={{ duration: 5 + Math.random() * 6, repeat: Infinity, delay: Math.random() * 4 }}
      />
    ))}

    <motion.div
      animate={{ opacity: [0.2, 0.5, 0.2] }}
      transition={{ duration: 4, repeat: Infinity }}
      className="absolute inset-8 pointer-events-none"
      style={{ border: '1px solid rgba(212,175,55,0.2)', borderRadius: '2px', boxShadow: '0 0 80px rgba(212,175,55,0.06), inset 0 0 80px rgba(212,175,55,0.03)' }}
    />

    <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
      <motion.p
        initial={{ opacity: 0, letterSpacing: '0.1em' }}
        whileInView={{ opacity: 1, letterSpacing: '0.45em' }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className="text-gold uppercase text-xs font-semibold mb-10"
        style={{ textShadow: '0 0 20px rgba(212,175,55,0.6)' }}
      >
        Die Lösung · Die Masterclass
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="text-5xl md:text-7xl font-serif text-cream leading-tight mb-10"
      >
        Der{' '}
        <span className="italic text-transparent bg-clip-text bg-gold-gradient"
          style={{ filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.4))' }}>
          Love Shift
        </span>
        {' '}&{' '}
        <span className="italic text-transparent bg-clip-text bg-gold-gradient"
          style={{ filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.4))' }}>
          Feminine Business
        </span>
        {' '}Masterclass.
      </motion.h2>

      <div className="space-y-8 text-lg text-cream/70 font-light leading-relaxed mb-14">
        {[
          { delay: 0.2, text: 'In dieser 90-minütigen Initiation öffnen wir gemeinsam das Tor zu deiner magnetischen Essenz. Das ist keine gewöhnliche Masterclass. Das ist eine Energieübertragung. Ein Raum, in dem du dich erlaubst, gesehen zu werden – von mir und vor allem von dir selbst.' },
          { delay: 0.4, text: 'Du wirst körperlich spüren, wie sich etwas in deinem Nervensystem verschiebt. Wie sich die chronische Anspannung des Wartens, des Hustlens, des Nicht-genug-Seins auflöst. Wie ein Raum in deiner Brust entsteht, den du vielleicht seit Jahren nicht mehr gespürt hast: Stille. Klarheit. Kraft.' },
          { delay: 0.6, highlight: true, text: 'Stell dir vor, du verlässt diese Masterclass mit dem unerschütterlichen Wissen: Ich muss nicht mehr jagen. Ich muss nicht mehr kämpfen. Ich bin der Magnet. Und alles, was für mich bestimmt ist, kommt zu mir – weil ich endlich aufgehört habe, es wegzudrücken.' },
        ].map((block, i) => (
          <motion.p key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: block.delay, duration: 0.8 }}
            className={block.highlight ? 'text-cream font-serif italic text-xl' : ''}
          >
            {block.text}
          </motion.p>
        ))}
      </div>

      <motion.a
        href="#anmeldung-formular"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        whileHover={{ scale: 1.06, boxShadow: '0 0 80px rgba(212,175,55,0.9), 0 0 160px rgba(212,175,55,0.4)' }}
        whileTap={{ scale: 0.97 }}
        className="inline-block px-16 py-6 bg-gold-gradient text-dark font-bold uppercase tracking-widest text-sm cursor-pointer relative overflow-hidden group"
        style={{ boxShadow: '0 0 40px rgba(212,175,55,0.5)', borderRadius: '2px' }}
      >
        <span className="relative z-10">✦ Sichere dir deinen Platz – Kostenlos →</span>
        <div className="absolute inset-0 bg-white/15 translate-x-[-110%] skew-x-[-20deg] group-hover:translate-x-[200%] transition-transform duration-1000 ease-in-out" />
      </motion.a>
    </div>
  </section>
);

export default ParadigmShift;